import "./App.css";
import theme from "./theme/colors";

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import RegistryLandingPageView from './RegistryLandingPageView';
import RegistryProjectDetailsPageView from './RegistryProjectDetailsPageView';
import RegistryTransactionPageView from "./RegistryTransactionPageView";
import "antd/dist/reset.css";
import { Layout, Button, Space, Grid } from "antd";
import { ToolOutlined } from "@ant-design/icons";
import { useTheme } from './contexts/ThemeContext';

const { Header, Content } = Layout;
const { useBreakpoint } = Grid;

function App() {
  const { isDarkMode, toggleTheme } = useTheme();
  const screens = useBreakpoint();

  return (
    <Layout style={{
      height: '100vh'
    }}>
      <Header
      style={{
        position: "fixed",
        zIndex: 1000,
        width: "100%",
        backgroundColor: isDarkMode ? "#1f1f1f" : "#FFFFFF",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        boxShadow: isDarkMode ? "0 2px 8px rgba(0,0,0,0.45)" : "0 2px 8px rgba(0,0,0,0.06)",
        borderBottom: isDarkMode ? "1px solid #303030" : "1px solid #f0f0f0",
        height: 56,
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="/dockal-logo-brand.svg"
          alt="Dockal logo"
          style={{ height: screens.md ? 26 : 22 }}
        />
      </div>

      <Space>
        <Button
          type="text"
          icon={<ToolOutlined style={{ fontSize: 18, color: theme.primary }} />}
          onClick={toggleTheme}
          style={{
            padding: '4px 8px'
          }}
        />
      </Space>
    </Header>

    <Layout>
      <Content
        className="site-layout"
        style={{
          padding: '24px',
          marginTop: 56,
          backgroundColor: isDarkMode ? '#141414' : '#f5f5f5',
          minHeight: 'calc(100vh - 56px)',
        }}
      >
        <div
          className="site-layout-background"
          style={{
            padding: 24,
            minHeight: 500,
            backgroundColor: 'transparent',
          }}
        >
          <Router>
            <Switch>
              <Route exact path="/" component={RegistryLandingPageView} />
              <Route path="/:id/transaction" component={RegistryTransactionPageView} />
              <Route path="/:id" component={RegistryProjectDetailsPageView} />
            </Switch>
          </Router>
        </div>
      </Content>
    </Layout>
  </Layout>
  );
}

export default App;
